import script from "./EpDocModeloEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EpDocModeloEditPage.vue?vue&type=script&setup=true&lang=js"

import "./EpDocModeloEditPage.vue?vue&type=style&index=0&id=1eb25758&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eb25758"]])

export default __exports__